// This file contains the application version information
// It will be updated automatically by GitHub Actions

export const VERSION = {
  number: '1.0.111',
  buildDate: '2025-06-19T02:52:40Z',
  commitHash: '3d8104ce7ec3b7fe5e28779086fb083ec8f45b12',
}

export const getVersionString = () => {
  return `v${VERSION.number} (${VERSION.commitHash.substring(0, 7)})`
}
